import { AppBar, Toolbar, Box, Typography, Stack, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logos/coco_logo1.png";
import useResponsiveHelper from "../hooks/useResponsiveHelper";
import MobileMenu from "../components/MobileMenu";
import { styled } from "@mui/system";

const HEADER_HEIGHT = 100;

export default function Header() {
  const theme = useTheme();
  const { isMobile, isTablet } = useResponsiveHelper();
  const { pathname } = useLocation();
  const isHomepage = pathname === "/";

  const menuList = ["Order", "Locations", "Drinks", "Apply", "About", "Contact", "Catering"];

  const StyledLink = styled(Link)(() => ({
    borderRadius: "30px",
    padding: "10px",
    marginRight: "35px",
    textDecoration: "none",
    fontFamily: "Fredoka",
    color: isHomepage ? "#fff" : theme.palette.secondary.main,
  }));

  return (
    <AppBar
      position="fixed"
      elevation={isHomepage ? 0 : 4}
      sx={{
        zIndex: 10,
        height: `${HEADER_HEIGHT}px`,
        backgroundColor: isHomepage ? "transparent" : theme.palette.background.default,
      }}
    >
      <Toolbar
        sx={{
          height: `${HEADER_HEIGHT}px`,
          backgroundColor: "transparent",
          // optional readability overlay only on homepage
          backgroundImage: isHomepage
            ? "linear-gradient(to bottom, rgba(0,0,0,0.35), rgba(0,0,0,0))"
            : "none",
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%" }}>
          <Link to="/">
            <Box component="img" alt="logo" src={logo} sx={{ m: "15px", width: "150px" }} />
          </Link>

          {!(isMobile || isTablet) && (
            <Typography variant="h5" sx={{ mt: "20px" }}>
              {menuList.map((item) => (
                <StyledLink
                  key={item}
                  to={item === "Apply" ? `/apply-online` : `/${item.toLowerCase()}`}
                >
                  {item}
                </StyledLink>
              ))}
            </Typography>
          )}

          {(isMobile || isTablet) && (
            <Box sx={{ display: "flex", alignItems: "center", mr: "20px" }}>
              <MobileMenu
                menuList={menuList}
                bg_color={isHomepage ? "transparent" : theme.palette.background.default}
              />
            </Box>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
}